import { TagManagerService } from './tagManager.service'

export class EmailNewsLetterObserver {
    constructor() {
        this.service = new TagManagerService();
    }

    next(response) {
        if(response.data) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(this.service.buildEmailNewsLetter());
        }
    }

    error(error) {}

    complete() {}
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/tag-manager/emailNewsLetter.observer.js